// src/utils/filters.js
import { 
  Lightbulb, 
  Wrench, 
  BookOpen, 
  Palette,
  Twitch,
  Code,
  Paintbrush,
  LayoutDashboard
} from 'lucide-react';

export const contentTypeFilters = [
  { type: "Inspiratie", color: "bg-blue-500", Icon: Lightbulb },
  { type: "AI-Tools", color: "bg-purple-500", Icon: Wrench },
  { type: "How-to's", color: "bg-green-500", Icon: BookOpen },
  { type: "Eigen projecten", color: "bg-yellow-500", Icon: Palette },
  { type: "Overige", color: "bg-gray-500", Icon: Twitch },
];

export const themeFilters = [
  { type: "Development", color: "bg-[#3cdc96]", Icon: Code },
  { type: "Creatie", color: "bg-[#e8c2d9]", Icon: Paintbrush },
  { type: "Project management", color: "bg-[#82e6e6]", Icon: LayoutDashboard },
];

export const getFilterColor = (filters, type) => {
  const filter = filters.find((f) => f.type === type);
  return filter ? filter.color : "bg-gray-500";
};